module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="farm-favourite-button-inner"></div>\n';
}
return __p;
};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/menu/common/favourite-button/favourite-button.html
 ** module id = 143
 ** module chunks = 1 2 3 4 5 6 7 10 11 13 16 17 22 25 26 137
 **/